// extracted by mini-css-extract-plugin
export default {"container":"LeftArrowButton_container__7cyxo","visible":"LeftArrowButton_visible__0a1Po","hidden":"LeftArrowButton_hidden__24Wwi"};